import { render, staticRenderFns } from "./firewall.vue?vue&type=template&id=09dd8942&scoped=true&"
import script from "./firewall.vue?vue&type=script&lang=js&"
export * from "./firewall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09dd8942",
  null
  
)

export default component.exports